import { motion } from "framer-motion";

import flower from "./images/цветочек.png";
import letter from "./images/конверт.png";
import frame from "./images/рамка-3.png";
import dress from "./images/dress.png";

export const Wishes = () => {
  return (
    <section className="w-full py-12 sm:py-24">
      <div className="relative mx-auto max-w-xl">
        <img src={frame} alt="Рамка" className="w-full h-auto" />

        <div className="absolute left-[5%] right-[5%] top-[4%] bottom-[19%] flex flex-col items-center justify-between text-center">
          <h1
            className="text-lg font-bold tracking-wider"
            style={{ fontFamily: "ofont_flow" }}
          >
            ПОЖЕЛАНИЯ
          </h1>

          <p className="text-sm sm:text-base leading-relaxed text-[var(--secondary-soft)]">
            Если хотите подарить нам ценный и нужный подарок, мы будем
            благодарны за вклад в бюджет нашей молодой семьи.
          </p>

          <motion.img
            src={letter}
            alt="Конверт"
            className="h-10 w-10 sm:h-14 sm:w-14 shrink-0 object-contain"
            animate={{ y: [0, -5, 0] }}
            transition={{ duration: 0.4, repeat: Infinity }}
          />

          <p className="text-sm sm:text-base leading-relaxed text-[var(--secondary-soft)]">
            Просим не обременять себя выбором цветов. Ваше присутствие скрасит
            этот день ярче любых букетов!
          </p>

          <motion.img
            src={flower}
            alt="Цветок"
            className="h-12 w-12 sm:h-16 sm:w-16 shrink-0 object-contain"
            animate={{ rotate: 360 }}
            transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
          />

          <p className="text-sm sm:text-base leading-relaxed text-[var(--secondary-soft)]">
            Будем признательны, если в белом будет только невеста. Если хотите
            поддержать стилистику нашей свадьбы, придерживайтесь пастельных
            оттенков в своих нарядах.
          </p>

          <motion.img
            src={dress}
            alt="Платье"
            className="h-12 w-12 sm:h-16 sm:w-16 shrink-0 object-contain"
            animate={{ rotate: [0, -10, 10, -10, 10, 0] }}
            transition={{ duration: 2.3, repeat: Infinity }}
          />

          <p className="text-sm sm:text-base leading-relaxed text-[var(--secondary-soft)]">
            Нам будет особенно приятно, если вы придёте всей семьей.
          </p>
        </div>
      </div>
    </section>
  );
};
